import { render, staticRenderFns } from "./DocumentPiV2.vue?vue&type=template&id=2dce6212&"
import script from "./DocumentPiV2.vue?vue&type=script&lang=js&"
export * from "./DocumentPiV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2dce6212')) {
      api.createRecord('2dce6212', component.options)
    } else {
      api.reload('2dce6212', component.options)
    }
    module.hot.accept("./DocumentPiV2.vue?vue&type=template&id=2dce6212&", function () {
      api.rerender('2dce6212', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/LMSGiframe/components/DocumentPiV2.vue"
export default component.exports